'use strict';

var _classCallCheck = require("/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var YAMLException = /*#__PURE__*/function () {
  function YAMLException(reason) {
    var mark = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var isWarning = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    _classCallCheck(this, YAMLException);

    this.name = 'YAMLException';
    this.reason = reason;
    this.mark = mark;
    this.message = this.toString(false);
    this.isWarning = isWarning;
  }

  _createClass(YAMLException, [{
    key: "getClassIdentifier",
    value: function getClassIdentifier() {
      var superIdentifiers = [];
      return superIdentifiers.concat(YAMLException.CLASS_IDENTIFIER);
    }
  }, {
    key: "toString",
    value: function toString() {
      var compact = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var result;
      result = 'JS-YAML: ' + (this.reason || '(unknown reason)');

      if (!compact && this.mark) {
        result += ' ' + this.mark.toString();
      }

      return result;
    }
  }], [{
    key: "isInstance",
    value: function isInstance(instance) {
      if (instance != null && instance.getClassIdentifier && typeof instance.getClassIdentifier == "function") {
        var _iterator = _createForOfIteratorHelper(instance.getClassIdentifier()),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var currentIdentifier = _step.value;
            if (currentIdentifier == YAMLException.CLASS_IDENTIFIER) return true;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      return false;
    }
  }]);

  return YAMLException;
}();

YAMLException.CLASS_IDENTIFIER = "yaml-ast-parser.YAMLException";
module.exports = YAMLException;